// Add your custom JS here.

jQuery(function($){
    if (window.matchMedia('(min-width: 1280px)').matches) {
    var logo = $('.home .navbar-brand img');
    // ボタン非表示
   // logo.hide();
    // 100px スクロールしたらボタン表示
    $(window).scroll(function () {
       if ($(this).scrollTop() > 271) {
            logo.fadeIn();
       } else {
            logo.fadeOut();
       }
    });
}


	// 目次の出力に使用する変数
	var sommaire = '<h6>index</h6><ul>';
	// 目次の階層の判断に使用する変数
	var hierarchy;
	// h2・h3の判断に使用する変数 
	var element = 0;
	// 目次の項目数をカウントする変数
	var count = 0;
    
    $('#page-exam-sidebar-wrapper .entry-content h2, #page-about-sidebar-wrapper .entry-content h2, #page-support-sidebar-wrapper .entry-content h2, .page-seminar .entry-content h2').each(function(){
    	// 目次の項目数のカウントを増加 
		count ++;  
		// h2タグにIDの属性値を指定
		this.id = 'chapter-' + count;
		    
		// 現在のループで扱う要素を判断する条件分岐
		if(this.nodeName == 'H2'){
			element = 0;
		}else{               
			element = 1;
		}  
        
		// 現在の状態を判断する条件分岐
		if(hierarchy === element){ // h2またはh3がそれぞれ連続する場合
			sommaire += '</li>';
		}else if(count == 1){ // 最初の項目の場合
			hierarchy = 0;
		} 
        
		// 目次の項目を作成。※次のループで<li>の直下に<ol>タグを出力する場合ががあるので、ここでは<li>タグを閉じていません。
		sommaire += '<li><a href="#' + this.id + '">' + $(this).html() + '</a>';  
	});
    
	// 目次の最後の項目をどの要素から作成したかにより、タグの閉じ方を変更
	if(element == 0){
		sommaire += '</li></ul>';
	}else if(element == 1){
		sommaire += '</li></ul></li></ul>';
	}
	
	// ページ内のh2が3つ以上の場合目次を出力
	if(count < 2){
		$('#sommaire').remove();
	}else{
		$('#sommaire').html(sommaire);
	}




    $(function(){
        $("#support-menu .menu-item-has-children > a, .sidebar-members .menu-item-has-children > a, #support-about .menu-item-has-children > a").on("click", function() {
            $(this).removeAttr('href').toggleClass('show');
            $(this).next().slideToggle();
        });
        });

		if (window.matchMedia("(min-width: 576px)").matches) {
        $(function(){
            var pagetop = $('.top');
            var height = $(window).height();
            pagetop.hide();
            $(window).scroll(function () {
               if ($(this).scrollTop() > height) {
                    pagetop.fadeIn();
               } else {
                    pagetop.fadeOut();
               }
            });
            pagetop.click(function () {
               $('body, html').animate({ scrollTop: 0 }, 500);
               return false;
            });
          });
		}

});
